import { useState, useEffect, useCallback } from 'react'
import { clientBenefitsService } from '../services/clientBenefitsService'
import type { AvailableBenefitTier } from '../types'

export function useAvailableBenefits(category?: string) {
  const [tiers, setTiers] = useState<AvailableBenefitTier[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await clientBenefitsService.getAvailable(category)
      setTiers(response.tiers)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar beneficios disponibles')
    } finally {
      setIsLoading(false)
    }
  }, [category])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { tiers, isLoading, error, refetch: fetchData }
}
